var u = Object.defineProperty;
var b = (a, e, t) => e in a ? u(a, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[e] = t;
var l = (a, e, t) => (b(a, typeof e != "symbol" ? e + "" : e, t), t);
const h = document.documentElement.lang, i = h.length > 2 ? h.substring(0, 2) : h, k = {
  acceptRequired: {
    de: "Nur notwendige Cookies zulassen",
    en: "Accept required cookies only"
  },
  acceptAll: {
    de: "Alle Cookies zulassen",
    en: "Accept all cookies"
  },
  acceptTracking: {
    de: "Auch Tracking-Cookies zulassen",
    en: "Accept tracking cookies"
  },
  acceptSelection: {
    de: "Auswahl bestätigen",
    en: "Accept selected"
  },
  status: {
    de: "Ihre aktuelle Einstellung: ",
    en: "Your current setting: "
  },
  statusRequiredAccepted: {
    de: "Nur notwendige Cookies zugelassen",
    en: "Only required cookies accepted"
  },
  statusAllAccepted: {
    de: "Alle Cookies zugelassen",
    en: "All cookies accepted"
  },
  statusTrackingAccepted: {
    de: "Auch Tracking-Cookies zugelassen",
    en: "Tracking cookies accepted"
  },
  openConfig: {
    de: "Einstellungen",
    en: "Configuration"
  },
  on: {
    de: "An",
    en: "On"
  },
  off: {
    de: "Aus",
    en: "Off"
  },
  imprint: {
    de: "Impressum",
    en: "Imprint"
  },
  privacyPolicy: {
    de: "Datenschutz",
    en: "Privacy policy"
  },
  mainPanelTitle: {
    de: "Ihre Cookie-Einstellungen",
    en: "Your cookie settings"
  },
  mainPanelText: {
    de: 'Um unsere Websites in Sachen Nutzerfreundlichkeit, Effektivität und Sicherheit für Sie zu optimieren, verwenden wir Cookies. Das sind kleine Textdateien, die auf Ihrem Datenendgerät abgelegt und in Ihrem Browser gespeichert werden.<br/> Darunter sind Cookies, die technisch für den Betrieb unserer Websites notwendig sind, sowie Cookies zur anonymen Webanalyse oder für erweiterte Funktionen und Services. Weitere Informationen dazu finden Sie in unserer <a href="/datenschutz">Datenschutzerklärung</a>.<br/> Sie entscheiden, für welche Kategorien Sie dem Einsatz von Cookies zustimmen möchten und für welche nicht. Bitte berücksichtigen Sie, dass Ihnen je nach Auswahl ggf. nicht mehr alle Funktionen unserer Websites zur Verfügung stehen.',
    en: 'We use cookies to optimize the user-friendliness, effectiveness, and security of our websites for you. Cookies are little text files that are deposited on your data terminal and stored in your browser.<br/>Among these, are cookies that are essential to the technical functionality of our websites, as well as cookies for anonymous web analysis or expanded functions and services. Further information on cookies can be found in our <a href="en/privacy-policy">data privacy statement</a> (in German only).<br/>You decide which categories you want to approve the use of cookies for and which ones you do not want to approve. Please keep in mind that making certain selections may mean that some of the features of our websites will no longer be available to you.'
  },
  configPanelTitle: {
    de: "Cookie-Einstellungen bearbeiten",
    en: "Edit cookie settings"
  },
  configPanelText: {
    de: "<p>Optionaler Text...</p>",
    en: "<p>Optionaler Text...</p>"
  }
}, p = (a, e, t, o, s, n, r, c) => `<div class="cookiebanner cookiebanner--minimal" aria-modal="true" aria-labelledby="cookiebanner__label-main-panel" role="dialog" tabindex="0">
  <div class="cookiebanner__inner">
    <div class="cookiebanner__main-panel">
      <span id="cookiebanner__label-main-panel" class="cookiebanner__heading">${a.mainPanelTitle[i]}</span>
      ${a.mainPanelText[i] ? `${a.mainPanelText[i]}` : ""}
        ${c && c === "deny" ? `<p class="cookiebanner__status"><strong>${a.status[i]} ${a.statusRequiredAccepted[i]}</strong></p>` : c && c === "acceptTracking" ? `<p class="cookiebanner__status"><strong>${a.status[i]} ${a.statusTrackingAccepted[i]}</strong></p>` : c && c === "acceptAll" ? `<p class="cookiebanner__status"><strong>${a.status[i]} ${a.statusAllAccepted[i]}</strong></p>` : ""}
      <div class="cookiebanner__buttons">
        <button data-consent="deny">${a.acceptRequired[i]}</button>
        ${t === "required-tracking" ? ` <button data-consent="acceptTracking">${a.acceptTracking[i]}</button>` : ""}
        ${t === "required-all" ? ` <button data-consent="acceptAll">${a.acceptAll[i]}</button>` : ""}
      </div>
      ${o ? `
      <div class="cookiebanner__info-panel">
          <ul class="cookiebanner__list">
        ${e.map(
  (d, g) => d.showInInfoPanel ? `<li class="cookiebanner__list-item">
                <button class="cookiebanner__shower-button" aria-expanded="false">
                    <span>${d.name[i]}</span>
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                      <path fill="currentColor" d="M 7,8.167306 12.444903,2.722403 14,4.2775 l -7,7 -7,-7 1.5550972,-1.555097 z" />
                    </svg>
                  </button>
                <div class="cookiebanner__shower-panel">
                    <div class="cookiebanner__shower-panel-inner">
                        ${d.text[i]}
                    </div>
                </div>
            </li>` : ""
).join("")}
            </ul>
        </div>
             ${n || r ? `
                <div class="cookiebanner__links">
                    ${r ? `<a href=${r.url} target=${r.target}">${r.label}</a>` : ""}
                    ${n ? `<a href=${n.url} target=${n.target}>${n.label}</a>` : ""}
                </div>
                ` : ""}
      ` : ""}
    </div>
  </div>
</div>`, m = (a, e, t, o, s, n, r) => `<div class="cookiebanner cookiebanner--minimal-with-config" aria-modal="true" aria-labelledby="cookiebanner__label-main-panel cookiebanner__label-config-panel" role="dialog" tabindex="0">
  <div class="cookiebanner__inner">
  ${s ? "" : `
    <div class="cookiebanner__main-panel">
      <span id="cookiebanner__label-main-panel" class="cookiebanner__heading">${a.mainPanelTitle[i]}</span>
      ${a.mainPanelText[i] ? `${a.mainPanelText[i]}` : ""}
      <div class="cookiebanner__buttons">
        <button data-consent="deny">${a.acceptRequired[i]}</button>
        ${t === "required-tracking" ? ` <button data-consent="acceptTracking">${a.acceptTracking[i]}</button>` : ""}
        ${t === "required-all" ? ` <button data-consent="acceptAll">${a.acceptAll[i]}</button>` : ""}
        <button data-show-config>${a.openConfig[i]}</button>
      </div>
             ${n || r ? `
                <div class="cookiebanner__links">
                    ${r ? `<a href=${r.url} target=${r.target}">${r.label}</a>` : ""}
                    ${n ? `<a href=${n.url} target=${n.target}>${n.label}</a>` : ""}
                </div>
                ` : ""}
    </div>
  `}
  ${s ? `
        <div class="cookiebanner__config-panel">
      <span id="cookiebanner__label-config-panel" class="cookiebanner__heading">${a.configPanelTitle[i]}</span>
      ${a.configPanelText[i] ? `${a.configPanelText[i]}` : ""}
      <ul class="cookiebanner__list">
        ${e.map(
  (c, d) => `<li class="cookiebanner__list-item">
                  <input type="checkbox" id="${c.type}-enabled" class="sr-only" ${c.type === "required" ? "checked readonly disabled" : ""} ${c.isChecked ? "checked" : ""} >
                  <label for="${c.type}-enabled">
                      <span class="cookiebanner__cookie-label">${c.name[i]}</span>
                       <span class="cookiebanner__toggler" aria-hidden="true"></span>
                      <span class="cookiebanner__toggler-text is-on" aria-hidden="true" tabindex="-1">${a.on[i]}</span>
                      <span class="cookiebanner__toggler-text is-off" aria-hidden="true" tabindex="-1">${a.off[i]}</span>
                  </label>
                                  ${c.text ? `
                  <p>${c.text[i]}</p>
                  ` : ""}
            </li>`
).join("")}
      </ul>
      <div class="cookiebanner__buttons">
        <button data-consent="acceptSelection">${a.acceptSelection[i]}</button>
      </div>
    </div>
             ${n || r ? `
                <div class="cookiebanner__links">
                    ${r ? `<a href=${r.url} target=${r.target}">${r.label}</a>` : ""}
                    ${n ? `<a href=${n.url} target=${n.target}>${n.label}</a>` : ""}
                </div>
                ` : ""}
  ` : ""}
  </div>
</div>`, f = (a, e, t, o, s, n, r) => `<div class="cookiebanner cookiebanner--tablist" aria-modal="true" aria-labelledby="cookiebanner__label-main-panel" role="dialog" tabindex="0">
    <div class="cookiebanner__inner">
        <div class="cookiebanner__main-panel">
            <span id="cookiebanner__label-main-panel" class="cookiebanner__heading">${a.mainPanelTitle[i]}</span>
            ${a.mainPanelText[i] ? `${a.mainPanelText[i]}` : ""}
            <div class="cookiebanner__cookie-section">
                <ul class="cookiebanner__tablist" role="tablist">
                  ${e.map(
  (c, d) => `<li class="cookiebanner__tablist-item" role="presentation">
                          <div class="cookiebanner__tablist-head">
                            <button
                                id="cookiebanner__tab-${d}"
                                class="cookiebanner__tab cookiebanner__cookie-label"
                                aria-controls="cookiebanner__tabpanel-${d}"
                                aria-selected="false"
                                role="tab"
                                >
                                <span>${c.name[i]}</span>
                            </button>
                             <input type="checkbox" id="${c.type}-enabled"  ${c.type === "required" ? "checked readonly disabled" : ""} ${c.isChecked ? "checked" : ""} data-type="${c.type}" class="sr-only">
                              <label for="${c.type}-enabled" class="cookiebanner__checkbox">
                                <span class="sr-only">${c.name[i]}</span>
                                <span class="cookiebanner__toggler" aria-hidden="true"></span>
                                <span class="cookiebanner__toggler-text is-on" aria-hidden="true" tabindex="-1">${a.on[i]}</span>
                                <span class="cookiebanner__toggler-text is-off" aria-hidden="true" tabindex="-1">${a.off[i]}</span>
                            </label>
                          </div>
                          <div class="cookiebanner__tabpanel" id="cookiebanner__tabpanel-${d}" aria-labelledby="cookiebanner__tab-${d}" aria-hidden="true" role="tabpanel">
                          ${c.text[i]}
                          </div>
                      </li>`
).join("")}
                </ul>
            </div>

            <div class="cookiebanner__buttons">
              <button data-consent="acceptSelection">${a.acceptSelection[i]}</button>
              <button data-consent="acceptAll" >${a.acceptAll[i]}</button>
            </div>
             ${n || r ? `
                <div class="cookiebanner__links">
                    ${r ? `<a href=${r.url} target=${r.target}">${r.label}</a>` : ""}
                    ${n ? `<a href=${n.url} target=${n.target}>${n.label}</a>` : ""}
                </div>
                ` : ""}
        </div>
    </div>
</div>`;
class $ {
  constructor(e) {
    l(this, "init", () => {
      this.onInit && this.onInit(), this.checkStorage("required") ? (this.setDefaultAttributes(), this.consentTypes.forEach((e) => {
        this.checkStorage(e.type) && (e.trackingScripts ? (this.createTrackingScripts(e.trackingScripts), this.onTrackingEnabled && this.onTrackingEnabled(e.type)) : this.onOptIn && this.onOptIn(e));
      })) : (this.setDefaultAttributes(), this.renderCookiebanner(!1)), this.bindOpenButton();
    });
    l(this, "setDefaultAttributes", (e = !0) => {
      this.consentTypes.forEach((t) => {
        e ? (t.isChecked = !1, t.alreadySet = !1) : this.checkStorage(t.type) ? (t.isChecked = !0, t.alreadySet = !0) : (t.isChecked = !1, t.alreadySet = !1);
      });
    });
    l(this, "bindOpenButton", () => {
      this.openerButtons.length && this.openerButtons.forEach((e) => {
        e.addEventListener("click", () => {
          this.firstRun = !1, this.setDefaultAttributes(!1), this.renderCookiebanner();
        });
      });
    });
    l(this, "renderCookiebanner", (e = !0) => {
      (!this.hideCookiebanner || !this.firstRun) && (document.body.insertAdjacentHTML(
        "beforeend",
        this.cookiebannerTemplate(
          this.labels,
          this.consentTypes,
          this.consentButtonTypes,
          this.showTemplateMinimalInfoPanel,
          e,
          this.imprintLink,
          this.privacyPolicyLink,
          window.localStorage.getItem(`${this.nameSpace}-status`)
        )
      ), this.banner = document.querySelector(this.cookiebannerClass), this.bindCookiebannerEvents(), this.onRender && this.onRender(this.banner));
    });
    l(this, "bindCookiebannerEvents", () => {
      this.handleKeyboardNavigation(), this.cookiebannerTemplate === f && this.initTabpanel(), this.handleBodyScroll(), this.bindCloseButtons(), this.bindShowConfigButton();
    });
    l(this, "handleKeyboardNavigation", () => {
      this.banner && this.banner.focus();
      const e = this.banner.querySelectorAll(
        'button, [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      ), t = e[0], o = e[e.length - 1];
      this.banner.addEventListener("keydown", (s) => {
        s.key === "Tab" && s.shiftKey ? document.activeElement === t && (o.focus(), s.preventDefault()) : s.key === "Tab" && document.activeElement === o && (t.focus(), s.preventDefault());
      });
    });
    l(this, "handleBodyScroll", () => {
      window.innerWidth <= 768 && (document.querySelector(this.cookiebannerClass) ? document.querySelector("html").style.overflow = "hidden" : document.querySelector("html").style.overflow = "");
    });
    l(this, "initTabpanel", () => {
      const e = document.querySelectorAll(this.cookiebannerTabClass), t = document.querySelectorAll(this.cookiebannerTabpanelClass);
      e[0].setAttribute("aria-selected", "true"), t[0].setAttribute("aria-hidden", "false"), e.forEach((o) => {
        o.addEventListener("click", () => {
          const s = o.getAttribute("aria-controls");
          e.forEach(
            (n) => n.setAttribute("aria-selected", "false")
          ), t.forEach(
            (n) => n.setAttribute("aria-hidden", "true")
          ), o.setAttribute("aria-selected", "true"), document.querySelector(`#${s}`).setAttribute("aria-hidden", "false"), document.querySelector(`#${s}`).focus();
        });
      });
    });
    l(this, "bindShowConfigButton", () => {
      const e = this.banner.querySelector("[data-show-config]");
      e && e.addEventListener("click", () => {
        this.banner.parentNode.removeChild(this.banner), this.renderCookiebanner();
      });
    });
    l(this, "bindCloseButtons", () => {
      const e = document.querySelectorAll("[data-consent]");
      e.length && e.forEach((t) => {
        t.addEventListener("click", () => {
          const o = t.dataset.consent, s = this.banner.querySelectorAll(
            'input[type="checkbox"]',
            this.banner
          );
          o === "deny" ? this.consentTypes.forEach((n) => {
            n.type === "required" ? n.isChecked = !0 : n.isChecked = !1;
          }) : o === "acceptTracking" ? this.consentTypes.forEach((n) => {
            n.type === "required" || n.trackingScripts ? n.isChecked = !0 : n.isChecked = !1;
          }) : o === "acceptAll" ? (s.length && s.forEach((n) => {
            n.checked = !0;
          }), this.consentTypes.forEach((n) => {
            n.isChecked = !0;
          })) : o === "acceptSelection" && s.length && s.forEach((n, r) => {
            this.consentTypes[r].isChecked = n.checked;
          }), this.closeCookiebanner(o);
        });
      });
    });
    l(this, "closeCookiebanner", (e) => {
      this.clearStorage(), this.consentTypes.forEach((t) => {
        t.isChecked && this.setStorage(t.type);
      }), window.localStorage.setItem(`${this.nameSpace}-status`, e), this.handleExternalScripts(), this.banner.parentNode.removeChild(this.banner), this.handleBodyScroll();
    });
    l(this, "handleExternalScripts", () => {
      this.consentTypes.forEach((e) => {
        !e.alreadySet && e.isChecked ? (e.trackingScripts ? this.handleTrackingOptIn(e) : this.onOptIn && this.onOptIn(e), e.alreadySet = !0) : e.alreadySet && !e.isChecked && (e.trackingScripts ? this.handleTrackingOptOut(e) : this.onOptOut && this.onOptOut(e), e.alreadySet = !1);
      });
    });
    l(this, "handleTrackingOptIn", (e) => {
      if (this.createTrackingScripts(e.trackingScripts), e.type === "matomo")
        document.cookie.indexOf("mtm_consent_removed") > -1 && _paq.push(["forgetUserOptOut"]);
      else if (e.type === "googleanalytics") {
        const t = document.body.dataset.trackingId;
        t && document.cookie.indexOf("ga-disable-" + t + "=true") > -1 && (document.cookie = "ga-disable-" + t + "=false; expires=Thu, 01 Jan 1970 00:00:01 UTC; path=/", window["ga-disable-" + t] = !1);
      }
    });
    l(this, "handleTrackingOptOut", (e) => {
      e.type === "matomo" ? _paq.push(["optUserOut"]) : e.type === "googleanalytics" && gaOptout(), this.scripts.length && this.scripts.forEach((t) => t.parentNode.removeChild(t));
    });
    l(this, "setStorage", (e) => {
      window.localStorage.setItem(`${this.nameSpace}-${e}-enabled`, !0);
    });
    l(this, "checkStorage", (e) => window.localStorage.getItem(`${this.nameSpace}-${e}-enabled`));
    l(this, "clearStorage", () => {
      const e = { ...window.localStorage }, t = Object.keys(e).filter(
        (o) => o.includes(this.nameSpace)
      );
      t.length && t.forEach((o) => {
        window.localStorage.removeItem(o);
      });
    });
    l(this, "createTrackingScripts", (e) => {
      e.length && e.forEach((t) => {
        const o = t.insertSelector;
        t.scriptLink && this.createScriptLink("script", t.scriptLink, o), t.script && this.createScriptTag("script", t.script, o), t.noscript && this.createScriptTag("noscript", t.noscript, o);
      });
    });
    l(this, "createScriptTag", (e, t, o) => {
      const s = document.createElement(e), n = document.createTextNode(t);
      s.appendChild(n), document.querySelector(o).appendChild(s), this.scripts.push(s);
    });
    l(this, "createScriptLink", (e, t, o) => {
      const s = document.createElement(e);
      s.setAttribute("async", ""), s.src = t, document.querySelector(o).appendChild(s), this.scripts.push(s);
    });
    this.nameSpace = e.nameSpace || "cookiebanner", this.cookiebannerClass = e.cookiebannerClass || ".cookiebanner", this.consentTypes = e.consentTypes, this.consentButtonTypes = e.consentButtonTypes || "required-all", this.cookiebannerTemplate = e.cookiebannerTemplate || p, this.cookiebannerTabClass = e.cookiebannerTabClass || ".cookiebanner__tab", this.cookiebannerTabpanelClass = e.cookiebannerTabpanelClass || ".cookiebanner__tabpanel", this.openerButtons = e.openerButtons || document.querySelectorAll("[data-cookiebanner-opener]"), this.onInit = e.onInit || null, this.onRender = e.onRender || null, this.onOptIn = e.onOptIn || null, this.onOptOut = e.onOptOut || null, this.onTrackingEnabled = e.onTrackingEnabled || null, this.showTemplateMinimalInfoPanel = e.showTemplateMinimalInfoPanel || !1, this.hideCookiebanner = e.hideCookiebanner || !1, this.imprintLink = e.imprintLink || null, this.privacyPolicyLink = e.privacyPolicyLink || null, this.labels = e.labels || k, this.scripts = [], this.firstRun = !0;
  }
}
export {
  $ as Cookiebanner,
  k as cookiebannerLabels,
  p as cookiebannerTemplateMinimal,
  m as cookiebannerTemplateMinimalConfig,
  f as cookiebannerTemplateTablist,
  i as lang
};
